import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const navButtonClass =
  'rounded p-1.5 text-[#676879] transition-colors hover:bg-[#f9f3f0] hover:text-[#C24914] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-[#676879]';

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export function Pagination({ page, pageSize, totalItems, onPageChange, onPageSizeChange }: PaginationProps) {
  if (totalItems === 0) return null;

  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[#D0D4E4] px-4 py-3">
      <label className="flex items-center gap-2 text-xs text-[#676879]">
        Itens por página:
        <select
          value={pageSize}
          onChange={event => onPageSizeChange(Number(event.target.value))}
          className="h-8 rounded border border-[#D0D4E4] bg-white px-2 text-xs text-[#323338]"
        >
          {PAGE_SIZE_OPTIONS.map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </label>
      <div className="flex items-center gap-1">
        <button type="button" onClick={() => onPageChange(1)} disabled={page === 1} className={navButtonClass} title="Primeira página">
          <ChevronsLeft size={16} />
        </button>
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page === 1} className={navButtonClass} title="Página anterior">
          <ChevronLeft size={16} />
        </button>
        <span className="min-w-[28px] rounded bg-[#C24914] px-2.5 py-1 text-center text-xs font-semibold text-white">{page}</span>
        <button type="button" onClick={() => onPageChange(page + 1)} disabled={page === totalPages} className={navButtonClass} title="Próxima página">
          <ChevronRight size={16} />
        </button>
        <button type="button" onClick={() => onPageChange(totalPages)} disabled={page === totalPages} className={navButtonClass} title="Última página">
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  );
}
